import {defineMessages, useIntl} from 'react-intl';

import {view} from '@sail/ui';

import {useAudience, useVisitor} from '../../../core/hooks/appHooks';

const messages = defineMessages({
  disclaimerLoggedOut: {
    id: 'conversations_assistant.subheader.disclaimer_logged_out',
    description: 'Subheader disclaimer for logged-out link audience users',
    defaultMessage:
      "You're chatting with an AI assistant that's here to help with your request.",
  },
  disclaimerLoggedIn: {
    id: 'conversations_assistant.subheader.disclaimer_logged_in',
    description: 'Subheader disclaimer for logged-in link audience users',
    defaultMessage:
      "You're chatting with an AI assistant that uses your account information to help with your request.",
  },
});

export const StripeAssistantSubheaderDisclaimer = () => {
  const intl = useIntl();
  const audience = useAudience();
  const visitor = useVisitor();

  if (audience !== 'link') {
    return null;
  }

  const isLoggedIn = visitor.sessionType !== 'anonymous';

  return (
    <view.div
      css={{
        stack: 'y',
        alignX: 'center',
        color: 'form.placeholder',
        font: 'label.small',
        flexGrow: 0,
        width: 'fill',
        paddingX: 'space.200',
        paddingTop: 'space.200',
        paddingBottom: 'space.100',
        zIndex: 2,
      }}
    >
      <view.div
        css={{
          textAlign: 'center',
          width: 'fill',
        }}
      >
        {isLoggedIn
          ? intl.formatMessage(messages.disclaimerLoggedIn)
          : intl.formatMessage(messages.disclaimerLoggedOut)}
      </view.div>
    </view.div>
  );
};
